import React, { useMemo, CSSProperties } from 'react';
import { useGetList } from 'react-admin';
import { useMediaQuery, Theme, Typography, Grid } from '@mui/material';
import { subDays, startOfDay } from 'date-fns';

import Welcome from './Welcome';
import QuestionSummary from './QuestionSummary';
import SubjectQuestionAnalysis from './SubjectQuestionAnalysis';
import QuickStats from '../../components/coaching-dashboard/QuickStats';
import DailyAttendanceSummary from '../../components/coaching-dashboard/DailyAttendanceSummary';
import FeeCollectionToday from '../../components/coaching-dashboard/FeeCollectionToday';
import EnrollmentTrends from '../../components/coaching-dashboard/EnrollmentTrends';
import BranchPerformance from '../../components/coaching-dashboard/BranchPerformance';
import UpcomingTests from '../../components/coaching-dashboard/UpcomingTests';

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '0.5em' },
    rightCol: { flex: 1, marginLeft: '0.5em' },
    singleCol: { marginTop: '1em', marginBottom: '1em' },
};

const Spacer = () => <span style={{ width: '1em' }} />;
const VerticalSpacer = () => <span style={{ height: '1em' }} />;

const Dashboard = () => {
    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('lg')
    );    
   
    return isXSmall ? (
        <div>
            <div style={styles.flexColumn as CSSProperties}>
               
                <VerticalSpacer />
                <QuestionSummary />
                <VerticalSpacer />
                <SubjectQuestionAnalysis />
                
                {/* Coaching Dashboard Widgets */}
                <VerticalSpacer />
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                    Coaching Management Dashboard
                </Typography>
                <QuickStats />
                <VerticalSpacer />
                <DailyAttendanceSummary />
                <VerticalSpacer />
                <FeeCollectionToday />
                <VerticalSpacer />
                <EnrollmentTrends />
                <VerticalSpacer />
                <BranchPerformance />
                <VerticalSpacer />
                <UpcomingTests />
            </div>
        </div>
    ) : isSmall ? (
        <div style={styles.flexColumn as CSSProperties}>
            <div style={styles.singleCol}>
               
                <VerticalSpacer />
                <QuestionSummary />
                <VerticalSpacer />
                <SubjectQuestionAnalysis />
                
                {/* Coaching Dashboard Widgets */}
                <VerticalSpacer />
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                    Coaching Management Dashboard
                </Typography>
                <QuickStats />
                <VerticalSpacer />
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <DailyAttendanceSummary />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <FeeCollectionToday />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <EnrollmentTrends />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <BranchPerformance />
                    </Grid>
                </Grid>
                <VerticalSpacer />
                <UpcomingTests />
            </div>
        </div>
    ) : (
        <>
          
            <VerticalSpacer />
            <QuestionSummary />
            <VerticalSpacer />
            <SubjectQuestionAnalysis />
            
            {/* Coaching Dashboard Widgets */}
            <VerticalSpacer />
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                Coaching Management Dashboard
            </Typography>
            <QuickStats />
            <VerticalSpacer />
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <DailyAttendanceSummary />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <FeeCollectionToday />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <EnrollmentTrends />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <BranchPerformance />
                </Grid>
            </Grid>
            <VerticalSpacer />
            <UpcomingTests />
        </>
    );
};

export default Dashboard;
